module.exports = __webpack_public_path__ + "static/merge-45dcdcae1ba9540383bb5c6574eafe64.png";